<section class="bg-white content-side mb-30 rounded-6">
  <div class="header">
    <div class="ico-book">
      <img alt="libro-de-e" [src]="urlIMG + 'libro-de-e.png'" />
    </div>
    <div class="mb-30 content-header">
      <!-- <div class="mb-10 title-header">{{'FormBook.ClaimSheet' | translate}}</div> -->
      <div class="header-description">
        <b>{{ "FormBook.Date" | translate }}: </b>{{ day }}
      </div>
      <div class="header-description">
        <b>Marcadores Deportivos del Perú S.A.C. RUC 20610450742</b>
      </div>
      <div class="header-description">
        Av. Manuel E. Olguin Nro 211, Int. 1002, Santiago de Surco, Lima
      </div>
    </div>
    <div class="logo-m247">
      <img alt="logo" [src]="urlIMG + 'logo-m247-color.png'" />
    </div>
  </div>
  <nz-divider></nz-divider>
  <div nz-row *ngIf="!loadMessage">
    <div nz-col nzSpan="24" class="mt-30">
      <form nz-form [formGroup]="validateForm">
        <div nz-col nzSpan="24" class="mb-30 title-content">
          <span class="text-number-red">1.</span>
          <h1 class="text-title">{{ "FormBook.IDConsumer" | translate }}</h1>
        </div>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="name" nzRequired
            >{{ "FormBook.FullName" | translate }}:</nz-form-label
          >
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            nzErrorTip="{{ 'FormValid.NameRequired' | translate }}"
          >
            <input
              nz-input
              id="name"
              formControlName="name"
              type="text"
              [maxlength]="200"
              [disabled]="sendingEmail"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="address" nzRequired
            >{{ "FormBook.Address" | translate }}:</nz-form-label
          >
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            nzErrorTip="{{ 'FormValid.AddressRequired' | translate }}"
          >
            <input
              nz-input
              id="address"
              formControlName="address"
              type="text"
              [maxlength]="300"
              [disabled]="sendingEmail"
            />
          </nz-form-control>
        </nz-form-item>

        <div nz-row>
          <div nz-col nzSpan="11">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="dni" nzRequired
                >{{ "FormBook.DNI" | translate }}:</nz-form-label
              >
              <nz-form-control
                [nzSpan]="24"
                nzHasFeedback
                nzErrorTip="{{ 'FormValid.DNIRequired' | translate }}"
              >
                <input
                  nz-input
                  id="dni"
                  formControlName="dni"
                  type="text"
                  [maxlength]="20"
                  [disabled]="sendingEmail"
                />
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="1"></div>

          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzFor="phoneNumber" nzRequired
                >{{ "FormBook.Phone" | translate }}:</nz-form-label
              >
              <nz-form-control
                [nzSpan]="24"
                [nzValidateStatus]="validateForm.controls['phoneNumber']"
                nzErrorTip="{{ 'FormValid.PhoneRequired' | translate }}"
              >
                <nz-input-group [nzAddOnBefore]="addOnBeforeTemplate">
                  <ng-template #addOnBeforeTemplate>
                    <nz-select
                      formControlName="phoneNumberPrefix"
                      class="phone-select"
                    >
                      <nz-option
                        nzLabel="{{ prefix.prefix }}"
                        nzValue="{{ prefix.prefix }}"
                        *ngFor="let prefix of typePrefix"
                      ></nz-option>
                    </nz-select>
                  </ng-template>
                  <input
                    formControlName="phoneNumber"
                    id="phoneNumber"
                    type="text"
                    [maxlength]="20"
                    nz-input
                    [disabled]="sendingEmail"
                  />
                </nz-input-group>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>
        <div nz-row>
          <div nz-col nzSpan="11">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired nzFor="email"
                >{{ "FormBook.Email" | translate }}:</nz-form-label
              >
              <nz-form-control
                [nzSpan]="24"
                nzHasFeedback
                [nzErrorTip]="emailErrorTpl"
              >
                <input
                  nz-input
                  formControlName="email"
                  type="email"
                  id="email"
                  [disabled]="sendingEmail"
                  (ngModelChange)="validateConfirmEmail()"
                  [maxlength]="200"
                />
                <ng-template #emailErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('email')">{{
                    "FormValid.EmailNotValid" | translate
                  }}</ng-container>
                  <ng-container *ngIf="control.hasError('required')">{{
                    "FormValid.EmailRequired" | translate
                  }}</ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>

          <div nz-col [nzXs]="1"></div>

          <div nz-col nzSpan="12">
            <nz-form-item>
              <nz-form-label [nzSpan]="24" nzRequired nzFor="emailConfirm"
                >{{ "FormBook.EmailConfirm" | translate }}:</nz-form-label
              >
              <nz-form-control
                [nzSpan]="24"
                nzHasFeedback
                [nzErrorTip]="emailConfirmErrorTpl"
              >
                <input
                  nz-input
                  type="email"
                  formControlName="emailConfirm"
                  id="emailConfirm"
                  [disabled]="sendingEmail"
                />
                <ng-template #emailConfirmErrorTpl let-control>
                  <ng-container *ngIf="control.hasError('required')">{{
                    "FormValid.EmailConfirm" | translate
                  }}</ng-container>
                  <ng-container *ngIf="control.hasError('confirm')">{{
                    "FormValid.EmailNotEqual" | translate
                  }}</ng-container>
                </ng-template>
              </nz-form-control>
            </nz-form-item>
          </div>
        </div>

        <nz-divider class="mt-30"></nz-divider>

        <div nz-col nzSpan="24" class="mt-30 mb-30 title-content">
          <span class="text-number-red">2.</span>
          <span class="text-title">{{
            "FormBook.DetailsClaim" | translate
          }}</span>
        </div>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="typeClaim" nzRequired
            >{{ "FormBook.ChoiceTypeCLaim" | translate }}:</nz-form-label
          >
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            nzErrorTip="{{ 'FormValid.TypeRequired' | translate }}"
          >
            <nz-radio-group
              formControlName="typeClaim"
              id="typeClaim"
              nzName="radiogroup"
            >
              <label nz-radio [nzValue]="type" *ngFor="let type of typeArray">{{
                type
              }}</label>
            </nz-radio-group>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="place"
            >{{ "FormBook.PlaceWhereEventsTake" | translate }}:</nz-form-label
          >
          <nz-form-control [nzSpan]="24">
            <label nz-radio formControlName="place" id="place"
              >Marcadores247</label
            >
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzFor="reference"
            >{{ "FormBook.Reference" | translate }}:</nz-form-label
          >
          <nz-form-control [nzSpan]="24" nzHasFeedback>
            <input
              nz-input
              id="reference"
              formControlName="reference"
              type="text"
              [maxlength]="50"
              [disabled]="sendingEmail"
            />
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="detail"
            >{{ "FormBook.Detail" | translate }}:</nz-form-label
          >
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            nzErrorTip="{{ 'FormValid.DetailRequired' | translate }}"
          >
            <nz-textarea-count [nzMaxCharacterCount]="1000">
              <textarea
                formControlName="detail"
                id="detail"
                nz-input
                rows="3"
                [disabled]="sendingEmail"
              ></textarea>
            </nz-textarea-count>
          </nz-form-control>
        </nz-form-item>

        <nz-form-item>
          <nz-form-label [nzSpan]="24" nzRequired nzFor="order"
            >{{ "FormBook.Order" | translate }}:</nz-form-label
          >
          <nz-form-control
            [nzSpan]="24"
            nzHasFeedback
            nzErrorTip="{{ 'FormValid.OrderRequired' | translate }}"
          >
            <nz-textarea-count [nzMaxCharacterCount]="1000">
              <textarea
                formControlName="order"
                id="order"
                nz-input
                rows="3"
                [disabled]="sendingEmail"
              ></textarea>
            </nz-textarea-count>
          </nz-form-control>
        </nz-form-item>

        <nz-divider class="mt-30"></nz-divider>

        <div nz-col nzSpan="24" class="mt-30">
          <span class="title-policies">{{
            "FormBook.PrivacyPolicies" | translate
          }}</span>
        </div>

        <div nz-col nzSpan="24">
          <span class="text-policies">{{
            "FormBook.SubTitlePolicies" | translate
          }}</span>
        </div>

        <div nz-col nzSpan="24" class="mt-15">
          <span class="description-policies">{{
            "FormBook.Text1" | translate
          }}</span>
        </div>
        <div nz-col nzSpan="24">
          <span class="description-policies">{{
            "FormBook.Text2" | translate
          }}</span>
        </div>
        <div nz-col nzSpan="24">
          <span class="description-policies">{{
            "FormBook.Text3" | translate
          }}</span>
        </div>

        <div nz-col nzSpan="24" class="mt-15">
          <span class="description-policies"
            >* {{ "FormBook.Text4" | translate }}</span
          >
        </div>
        <div nz-col nzSpan="24" class="mb-30">
          <span class="description-policies"
            >* {{ "FormBook.Text5" | translate }}</span
          >
        </div>

        <nz-divider></nz-divider>

        <div nz-col nzSpan="24" class="btn-submit">
          <button nz-button nzType="primary" (click)="submitForm()">
            {{ "Send" | translate }}
          </button>
        </div>
      </form>
    </div>
  </div>
  <div nz-row *ngIf="loadMessage">
    <div nz-col nzSpan="24">
      <nz-result
        nzStatus="success"
        nzTitle="{{ 'FormBook.ClaimSheetSend' | translate }}"
      >
        <div nz-result-extra>
          <button nz-button nzType="primary" [routerLink]="['/']">
            {{ "Back" | translate }}
          </button>
        </div>
      </nz-result>
    </div>
  </div>
</section>
